<template>
  <div class="article-header-container">
    <div class="article-header">预览临时链接</div>
  </div>
  <NormalNewsDetail
    :article="article"
    :reporter-list="reporterList"
    :relate-list="relateList"
    :info-list="infoList"
    :info-list-total="infoListTotal"
    :info-extend="infoExtend"
    view-model="preview"
  />
</template>

<script>
import { Toast } from "@vant/compat";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import Api from "@/api";
import Cookies from "js-cookie";
import NormalNewsDetail from "@/components/NormalNewsDetail.vue";
import watermark from "@/plugins/watermark";
import useShare from "@/composiables/useShare";

export default {
  name: "Preview",
  components: {
    NormalNewsDetail
  },
  setup() {
    const article = ref({ model: {} });
    const reporterList = ref([]);
    const relateList = ref([]);
    const infoList = ref([]);
    const infoListTotal = ref(0);
    const infoExtend = ref({});

    onMounted(() => {
      const route = useRoute();
      if (route.params.previewId) {
        // 获取文章预览详情
        Api.getPreArticle(route.params.previewId).then((res) => {
          if (res.code === 0) {
            const art = res.data;
            article.value = art;
            if (art.model.linkUrl) {
              window.location.href = art.model.linkUrl;
            }
            const url =
              "https://zsrbapp.zsnews.cn/mobile/newsDetail/#/preview/" +
              route.params.previewId;
            useShare(
              art.model.title,
              art.model.shareimg,
              art.model.summary,
              url
            );
            watermark(art.nickName + ":" + art.unionId);
          } else {
            Toast(res.error || "请求失败，请稍后再试");
          }
        });
      } else {
        Toast.fail("文章id缺失");
      }

      (function (doc, win) {
        var docEl = doc.documentElement,
          resizeEvt =
            "orientationchange" in window ? "orientationchange" : "resize",
          recalc = function () {
            var clientWidth = docEl.clientWidth;
            if (!clientWidth) return;
            if (clientWidth >= 750) {
              docEl.style.fontSize = 100 + "px";
            } else {
              docEl.style.fontSize = 100 * (clientWidth / 750) + "px";
            }
          };
        if (!doc.addEventListener) return;
        win.addEventListener(resizeEvt, recalc, false);
        recalc();
      })(document, window);
    });

    return {
      article,
      reporterList,
      relateList,
      infoList,
      infoListTotal,
      infoExtend
    };
  }
};
</script>

<style lang="scss" scoped>
.article-header-container {
  background-color: white;
  position: fixed;
  width: 100%;
  z-index: 99;
}
.article-header {
  color: red;
  font-size: 18px;
  padding: 1em;
  float: left;
}
</style>
